/* eslint-disable import/prefer-default-export */
import Vue from 'vue';

export const directive = {
  bind(el, { value }) {
    if (typeof IntersectionObserver === 'undefined') {
      value();
      return;
    }

    el.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          value();
          el.observer.disconnect();
        }
      });
    }, { threshold: 0.25 });
    el.observer.observe(el);
  },
  unbind(el) {
    el.observer.disconnect();
  },
};

Vue.directive('intersect', directive);
